import React from 'react';
import { Box } from '@mui/material';
import { TagsContext } from 'Modules/Components/TagsContext';

export default function TagPrinter({ tagIdList }) {
    const { tagList } = React.useContext(TagsContext);
    console.log('TagPrinter : ', {tagList});

    function printTags(tagIdList) {
        if (!tagIdList) return ''
        return Object.keys(tagIdList)
            .map((category) => {
                return tagIdList[category]
                    .map((tagid) => {
                        const tag = tagList[category]?.find(
                            (t) => t.id === tagid
                        );
                        return tag?.name;
                    })
                    .join(' ');
            })
            .join(', ');
    }

    return (
        <Box sx={{ whiteSpace: 'normal', maxWidth: 180 }}>
            {printTags(tagIdList)}
        </Box>
    );
}
